bz_app.factory('trackPermitMapService', [
  function () {
    var eventName = 'Permit Map Action'
    return {
      submitAddress: function (query, filters) {
        Track.send(
          eventName,
          this.defaultData({
            action: 'searched address',
            query: query,
            filters: filters,
          })
        )
      },
      clickPin: function (marker) {
        Track.send(
          eventName,
          this.defaultData({
            action: 'clicked pin',
            property: marker.property,
          })
        )
      },
      viewPropertyPage: function (property, link_source) {
        Track.send(
          eventName,
          this.defaultData({
            action: 'clicked property page link',
            link_source: link_source,
            property: property,
          })
        )
      },
      clickGeolocate: function () {
        Track.send(
          eventName,
          this.defaultData({
            action: 'clicked geolocate',
          })
        )
      },
      geolocateSuccess: function () {
        Track.send(
          eventName,
          this.defaultData({
            action: 'geolocate success',
          })
        )
      },
      defaultData: function (input) {
        var platform = isMobile.check() ? 'mobile' : 'desktop'
        return {
          action: input.action ? input.action : '',
          platform: platform,
          filters: input.filters ? input.filters : '',
          query: input.query ? input.query : '',
          link_source: input.link_source ? input.link_source : '',
          street_address:
            input.property && input.property.street
              ? input.property.street
              : '',
          city:
            input.property && input.property.city ? input.property.city : '',
          state:
            input.property && input.property.state ? input.property.state : '',
          user_role: UserData.user_role(),
        }
      },
    }
  },
])
